var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-bottom-sheet",
        {
          staticClass: "safe-bottom",
          attrs: { value: _vm.value },
          on: {
            "click:outside": function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "half-round",
              attrs: { elevation: "0", "min-height": "90vh" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "soli-close ma-3",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-title",
                { staticClass: "shadow-blue py-4" },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "shadow-blue mr-4",
                      staticStyle: { float: "left" },
                      attrs: { size: 64 },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          src: _vm.$page.props.auth.user.profile_photo_url,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "soli-grey title" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$page.props.auth.user.first_name) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        [
                          _c(
                            "Link",
                            {
                              attrs: {
                                href: `/profile/${_vm.$page.props.auth.user.id}/account`,
                              },
                            },
                            [
                              _vm._v(
                                "\n                            View Profile\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$page.props.staffView
                ? _c(
                    "v-bottom-navigation",
                    {
                      staticClass: "bottom-nav-bar shadow-grey",
                      attrs: { grow: "", app: "" },
                    },
                    _vm._l(_vm.items, function (item) {
                      return _c(
                        "v-btn",
                        {
                          key: item.title,
                          class: [
                            "py-2 soli-link",
                            _vm.page === item.comp || _vm.page == item.link
                              ? "v-btn--active"
                              : "btn-force-inactive",
                          ],
                          attrs: {
                            small: "",
                            "active-class": "btn-force-inactive",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$inertia.get(item.link)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c("v-icon", [_vm._v(_vm._s(item.icon))]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-container",
                [
                  _c(
                    "v-list",
                    [
                      _vm.is("Admin") && _vm.$page.props.staffView
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "soli-grey soli-round no-link",
                                  attrs: { href: "/admin" },
                                },
                                [_vm._v("Admin Panel")]
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$page.props.canWorkSummary &&
                      _vm.$page.props.auth.user.locations.length > 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "soli-grey flex soli-round",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("locationSelect")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$page.props.auth.user
                                          .selected_location.name
                                      )
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("my_location")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.can("Work")
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "soli-grey soli-round flex",
                                  on: { click: _vm.setView },
                                },
                                [
                                  _vm._v(
                                    "\n                            Student View\n                            "
                                  ),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        large: "",
                                        color: _vm.toggleView
                                          ? "dark"
                                          : "accent",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.toggleView
                                            ? "toggle_off"
                                            : "toggle_on"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.$page.props.staffView
                                ? _c("v-divider")
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.is("Teacher") && _vm.$page.props.staffView
                        ? _c(
                            "div",
                            [
                              _c(
                                "Link",
                                {
                                  attrs: {
                                    href: `/profile/${_vm.$page.props.auth.user.id}/availability`,
                                    data: { dayView: 1 },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "soli-grey no-link" },
                                    [_vm._v("Manage Availability")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.can("Use time clock") && _vm.$page.props.staffView
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "soli-grey soli-round",
                                  on: {
                                    click: function ($event) {
                                      _vm.showTimeClock = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Time Clock\n                            "
                                  ),
                                  _vm.$page.props.currentTimeClock
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass:
                                            "animate__animated animate__pulse animate__repeat-3 justify-end flex",
                                          attrs: { right: "", color: "error" },
                                        },
                                        [_vm._v("timer")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$page.props.staffView
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "soli-grey soli-round no-link",
                              attrs: { href: "/update-billing" },
                            },
                            [
                              _vm._v(
                                "\n                        Manage Payment Methods\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          staticClass: "soli-grey soli-round no-link",
                          on: {
                            click: function ($event) {
                              _vm.composeEmail = true
                            },
                          },
                        },
                        [_vm._v("Share Feedback")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          staticClass: "soli-grey soli-round no-link",
                          attrs: {
                            href: "https://musicologielessons.com/privacy",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.logout.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "soli-round",
                              staticStyle: { color: "#f44336 !important" },
                              on: { click: _vm.logout },
                            },
                            [_vm._v("Logout\n                        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showTimeClock
        ? _c("TimeClock", {
            attrs: { user: _vm.$page.props.auth.user },
            on: {
              success: function ($event) {
                return _vm.$emit("success")
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showTimeClock = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: ["feedback@musicologie.com"],
              errors: _vm.errors,
              user: _vm.$page.props.auth.user,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }